<template>
  <span class="page-edit-button-component d-inline-block">

    <!-- CHOOSE ACTION -->
    <b-modal ref="chooseActionPageModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Que souhaitez-vous faire ? </strong>
      </template>
      <div>
        <div class="row">
          <div class="col-sm-4 col-12">
            <b-button variant="outline-dark" pill block @click="$refs.chooseActionPageModal.hide(); $refs.movePageModal.show()">
              Déplacer cette page
            </b-button>
          </div>
          <div class="col-sm-4 col-12">
            <b-button variant="outline-primary" pill block @click="$refs.chooseActionPageModal.hide(); $refs.modifyPageModal.show()">
              Modifier cette page
            </b-button>
          </div>
          <div class="col-sm-4 col-12">
            <b-button variant="outline-danger" pill block @click="$refs.chooseActionPageModal.hide(); $refs.deletePageModal.show()">
              Supprimer cette page
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- DELETE PAGE -->
    <b-modal ref="deletePageModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Supprimer cette page </strong>
      </template>
      <div>
        <pageDeletionComponent
          :token="token"
          :page="node"
          v-on:page-deleted="$refs.deletePageModal.hide(); $refs.PageDeletedModal.show(); $emit('reset-folders-pages')"
        />
      </div>
    </b-modal>

    <b-modal ref="PageDeletedModal" size="lg" hide-footer title="Page supprimée">
      <div class="text-center">
        <p><strong>Votre page a bien été supprimée ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.PageDeletedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <!-- MODIFY PAGE -->
    <b-modal ref="modifyPageModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Modifier votre page </strong>
      </template>
      <div>
        <pageModificationComponent
          :token="token"
          :page="node"
          v-on:page-modified="pageModified($event)"
        />
      </div>
    </b-modal>

    <b-modal ref="PageModifiedModal" size="lg" hide-footer title="Page modifiée">
      <div class="text-center">
        <p><strong>Votre page a bien été modifiée ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.PageModifiedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <!-- MOVING PAGE -->
    <b-modal ref="movePageModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Déplacer votre page </strong>
      </template>
      <div>
        <pageMovingComponent
          :token="token"
          :page="node"
          v-on:page-moved="$refs.movePageModal.hide(); $refs.PageMovedModal.show(); $emit('reset-folders-pages')"
        />
      </div>
    </b-modal>

    <b-modal ref="PageMovedModal" size="lg" hide-footer title="Page déplacée">
      <div class="text-center">
        <p><strong>Votre page a bien été déplacée ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.PageMovedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <b-button v-if="showButton" variant="outline-secondary" size="sm" class="ml-2 page-edit-btn" @click.stop="showActionModal()">
      <v-icon name="edit" scale="1.1" />
    </b-button>

  </span>
</template>

<script>
import pageDeletionComponent from "@/components/page/pageDeletionComponent"
import pageModificationComponent from "@/components/page/pageModificationComponent"
import pageMovingComponent from "@/components/page/pageMovingComponent"

export default {
  name: 'pageEditButtonComponent',
  props: {
    token: String,
    node: Object,
    showButton: { type: Boolean, default: true }
  },
  components: {
    pageDeletionComponent,
    pageModificationComponent,
    pageMovingComponent
  },
  methods: {
    showActionModal () {
      this.$refs.chooseActionPageModal.show()
    },
    pageModified (value) {
      this.$refs.modifyPageModal.hide()
      this.$refs.PageModifiedModal.show()
      this.node.is_all_domains = value.is_all_domains
      this.node.is_modif_annuelle = value.is_modif_annuelle
      this.node.name = value.name
      this.node.notes = value.notes
      this.node.profondeur = value.profondeur
      this.node.url = value.url
      this.node.urls_exclude = value.urls_exclude
      this.node.urls_include = value.urls_include
      this.node.zone_analysed = value.zone_analysed
      this.node.zone_excluded_from_analysis = value.zone_excluded_from_analysis
      this.node.zone_crawled = value.zone_crawled
      this.node.url_for_file_root = value.url_for_file_root
      this.node.xpaths_clicked = value.xpaths_clicked
      this.node.has_bug = value.has_bug
      this.node.has_lenteurs = value.has_lenteurs
      this.$emit('page-modified', value)
    },
  }
}
</script>

<style scoped>
.page-edit-btn {
  vertical-align: middle;
}
</style>
